// extracted by mini-css-extract-plugin
module.exports = {"textBox":"styles_textBox__2pC9P","dragDropWrp":"styles_dragDropWrp__20vJ6","formElement":"styles_formElement__3WPtB","errorBox":"styles_errorBox__14D8Y"};